<div class="max-w-full overflow-hidden">
    <div class="relative">
        <ui-m000-c030-checkout-wrapper #wrapper onlyOneStep identifier="distribution">
            <div class="h-full" global>
                @if (vehicle()) {
                    <lib-distribution-receipt-step
                        [vehicleName]="vehicle().name"
                        [price]="vehicle().price.buy.toLocaleString('de-DE')"
                        [images]="vehicle().images"
                        [showAccesories]="vehicle().dealer.hasShop"
                        [accesories]="accessories()"
                        [accesorieLink]="'/fahrzeugbestand/' + vehicle().slug"
                        [envkv]="vehicle().envkvString"
                    />
                }
            </div>
            <lib-distribution-overview-step [vehicle]="vehicle()" />
            @defer {
                <lib-distribution-thanks-step />
            }
        </ui-m000-c030-checkout-wrapper>
    </div>
</div>
